import React from "react";
import { Client } from "../../../types/clients.types";
import { useSingleClient } from "../../../hooks/useClients";
import { dateConverter } from "../../../../../utils/dateConverter";
import { limitString } from "../../../../../utils/string.utils";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import PaygoListPresenter from "../../../../paygo/components/PaygoList/PaygoList/PaygoListPresenter";


export type ClientInfoType = Client & { "paygolist": unknown, "walletList": unknown };

export interface ClientInfoProps<T = unknown> {
  info: keyof ClientInfoType ;
  id?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    item?: T;

    goTo: () => void;
  }) => JSX.Element;
}

export default function ClientInfo({
  id,
  emptyText,
  info,
  styled,
  limitText,
  renderComponent,
}: ClientInfoProps) {
  const { singleClientQuery, clientId} = useSingleClient(id);
  const navigation = useNavigationApp();





  

  if (info === "paygolist") {
    return <PaygoListPresenter preFilter={{paygo_client: `=${clientId}`}}/>
  }

  const convertValue = (info: keyof ClientInfoType , value: any) => {
    switch (info) {
      case "client_created_at":
        return dateConverter(value);
      default:
        return value;
    }
  };





  if (renderComponent && singleClientQuery.data) {
    return renderComponent({
      labelRender: convertValue(info,singleClientQuery.data[info as keyof Client]),
      goTo: () => {navigation.goToSingleClient(singleClientQuery.data.client_id);},
    });}

  if (singleClientQuery.isLoading) return <>...</>;
  if (singleClientQuery.isError) return <>{emptyText || "-"}</>;

  return (
    <>
      {singleClientQuery.data &&
        limitString(
          convertValue(info, singleClientQuery.data[info as keyof Client]),
          limitText
        )}
    </>
  );
}
